/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import * as _ from 'lodash';

import template from './ad-density-page.component.html';
import {formatPercentage as formatPercentageValue} from '../../common/filters/format-percentage';
import {AppLocaleService} from '../../common/locale/app-locale.service';
import {AdnAdDensityService} from '../../../components/util/adn-ad-density.service';

@Component({
  standalone: false,
  selector: 'adn-ad-density-page',
  template
})
export class AdDensityPageComponent {
  url = 'https://www.vg.no/nyheter/i/8q7POE/krigen-i-midtoesten-trenger-ikke-aa-vente-paa-trump';
  bypassSave: boolean;
  triggered = false;
  fetching = false;
  deleting = false;
  adDensity: any[] = [];
  showScreenshots: boolean;
  showDirectResults = false;
  resp: any;

  constructor(
    @Inject(AdnAdDensityService) private readonly adnAdDensity: any,
    private readonly appLocale: AppLocaleService
  ) {
  }

  refresh(): void {
    this.fetching = true;
    this.adnAdDensity.fetchAll().then((data: any[]) => {
      this.adDensity = data;

      _.forEach(this.adDensity, (add) => {
        const flattenedDims = _.flatten(_.map(add.auctions, (auc: any) => _.flatten(_.map(auc, (val: any) => val))));

        add.old = {
          width: add.width,
          height: add.height,
          adCount: _.map(add.auctions, (auc: any) => auc).length,
          averageArea: _.reduce(flattenedDims, (sum: number, val: any) => sum + (val[0] * val[1]), 0) / flattenedDims.length
        };
        if (!add.densityInfo) {
          add.new = {};
          return;
        }
        add.new = {
          width: add.densityInfo.viewportWidth,
          height: add.densityInfo.viewportAreas.length * add.densityInfo.verticalScrollBy,
          viewportHeight: add.densityInfo.viewportHeight,
          adCount: add.densityInfo.ads.length,
          averageArea: _.reduce(add.densityInfo.ads, (sum: number, ad: any) => sum + (ad.width * ad.height), 0) / add.densityInfo.ads.length,
          adDensity: _.reduce(add.densityInfo.viewportAreas, (sum: number, va: any) => sum + va.density, 0) / add.densityInfo.viewportAreas.length / 2,
          adDensity2: _.reduce(_.filter(add.densityInfo.viewportAreas, (_v: any, index: number) => index % 2 === 0), (sum: number, va: any) => sum + va.density, 0) / add.densityInfo.viewportAreas.length,
          adDensityTop: _.reduce(_.filter(add.densityInfo.viewportAreas, (_v: any, index: number) => index === 0), (sum: number, va: any) => sum + va.density, 0),
          adDensityTop2: _.reduce(_.filter(add.densityInfo.viewportAreas, (_v: any, index: number) => index === 0 || index === 2), (sum: number, va: any) => sum + va.density, 0) / 2,
          adDensityTop3: _.reduce(_.filter(add.densityInfo.viewportAreas, (_v: any, index: number) => index === 0 || index === 2 || index === 4), (sum: number, va: any) => sum + va.density, 0) / 3
        };
      });
    }).finally(() => {
      this.fetching = false;
    });
  }

  deleteEntry(add: any, index: number): void {
    this.deleting = true;
    this.adnAdDensity.deleteEntry(add).then(() => {
      _.pullAt(this.adDensity, index);
    }).finally(() => {
      this.deleting = false;
    });
  }

  takeAdDensity(): void {
    this.triggered = true;
    this.adnAdDensity.takeAdDensity(this.url, this.bypassSave).then((data: any) => {
      this.resp = data;
    });
  }

  formatPercentage(input: number, decimals = 0): string {
    return formatPercentageValue(input, decimals, undefined, this.appLocale.getLocaleId());
  }
}
